function applyOnMobile() {
  // Hide splide product gallery on mobile
  document.getElementById('gallery-show-on-desktop-only').remove();
}

function applyOnDesktop() {
  // Hide product gallery on desktop
  document.getElementById('gallery-show-on-mobile-only').remove();
}

navigator.userAgent.match(/Android/i) ||
navigator.userAgent.match(/webOS/i) ||
navigator.userAgent.match(/iPhone/i) ||
navigator.userAgent.match(/iPad/i) ||
navigator.userAgent.match(/iPod/i) ||
navigator.userAgent.match(/BlackBerry/i) ||
navigator.userAgent.match(/Windows Phone/i)
  ? applyOnMobile()
  : applyOnDesktop();
